/* Copia con 5 pasos (05 = Regalos de Bryant), 14-oct-2026, solo para products/millo-gang-membership de la v4.
   Millo Gantel Club · «Lo que tienen los miembros» (ficha del club) · r6, 12-oct-2026.
   Escenario fijo: un único progreso de scroll (suavizado) mueve la entrada por el «%», las 4 ventajas y el cierre.
   Cada ventaja entra con su propio gesto: cortina (02), bandas con filo arena (03), borde en bloques (04) y botón que
   crece (cierre). Solo escribe variables CSS, transform, opacity y clip-path; los vídeos cargan cuando hacen falta y
   solo se reproduce el del paso activo. El precio cuenta por tiempo, una vez, y se queda en el precio de miembro.
   Escenario fijo también en móvil; solo con «reducir movimiento» cada ventaja es una pantalla normal. */
(function(){
  'use strict';
  var S = document.querySelector('[data-mgx]'); if (!S) return;
  var $ = function(q, r){ return (r || S).querySelector(q); };
  var $$ = function(q, r){ return [].slice.call((r || S).querySelectorAll(q)); };
  var stage = $('.mgx-stage'), steps = $$('.mgx-s'), LAST = steps.length - 1;
  var irm = $('.mgx-irm'), irs = $('.mgx-irs'), irv = $('.mgx-irv');
  var irc = $('.mgx-irc'), irs2 = irc && $('.mgx-irs', irc);
  var head = $('.mgx-in__head'), cue = $('.mgx-in__cue');
  var ctaIn = $('.mgx-cta__in'), btn = $('.mgx-cta__btn'), mk = $('.mgx-cta__mk'), ol = $('.mgx-cta__ol'), dot = $('.mgx-dot'), cv = $('.mgx-cv');
  var bars = $$('.mgx-ui b'), ui0 = $('.mgx-ui');
  var pTo = $('[data-mgx-to]'), pFrom = $('[data-mgx-from]'), pBox = $('.mgx-price');
  var s3bg = steps[2] && $('.mgx-bg', steps[2]), s4 = steps[3], sc4 = s4 ? $$('.mgx-sc', s4) : [];
  var mm = window.matchMedia ? function(q){ return window.matchMedia(q); } : function(){ return { matches: false }; };
  var mqRM = mm('(prefers-reduced-motion: reduce)');
  var mqLand = mm('(min-width: 761px) and (min-aspect-ratio: 4/5)');

  /* línea de tiempo, en pantallas de scroll (1 = 100vh) */
  var END = 7.35;
  var ZOOM = [.16, .9];
  var EN = [[.55, 1.2], [1.75, 2.35], [2.95, 3.5], [4.2, 4.8], [5.85, 6.45]];   /* entrada de cada paso */
  var HO = [[1.2, 1.75], [2.35, 2.95], [3.5, 4.2], [4.8, 5.85], [6.45, 7.35]];  /* el paso quieto: tallas, censura, cámara */
  var EX = [[1.75, 2.35], [2.95, 3.5], [4.2, 4.8], [5.85, 6.45], [7.35, 7.85]]; /* salida = entrada del siguiente */
  var OUT = [7.35, 7.85], MASK = [7.8, 8.4], ROW = [7.78, 8.1]; /* cierre sobrio: el titular entra en cuanto la franja se abre */

  function clamp(v, a, b){ return v < a ? a : v > b ? b : v; }
  function seg(v, a, b){ return clamp((v - a) / (b - a), 0, 1); }
  function o3(t){ return 1 - Math.pow(1 - t, 3); }
  function o5(t){ return 1 - Math.pow(1 - t, 5); }
  function io(t){ return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function lerp(a, b, t){ return a + (b - a) * t; }

  var pinned = false, port = false, still = false;
  var vh = window.innerHeight, cur = -1, tgt = 0, raf = 0, last = 0, near = false;
  var cache = new Map();
  function setv(el, k, v){ if (!el) return; var m = cache.get(el); if (!m) { m = {}; cache.set(el, m); } var s = typeof v === 'number' ? v.toFixed(4) : v; if (m[k] !== s) { m[k] = s; el.style.setProperty(k, s); } }
  function sets(el, k, v){ if (!el) return; var m = cache.get(el); if (!m) { m = {}; cache.set(el, m); } if (m[k] !== v) { m[k] = v; el.style[k] = v; } }

  /* ---------- vídeos ---------- */
  function srcOf(v){ return (port ? v.getAttribute('data-m') : v.getAttribute('data-d')) || ''; }
  function load(v){ var s = srcOf(v); if (!s) return false; if (v.getAttribute('src') !== s) { v.preload = 'auto'; v.src = s; } return true; }
  function play(v){ if (!v || still || document.hidden || !load(v)) return; v.muted = true; if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } }
  function pause(v){ if (v && !v.paused) v.pause(); }
  var vids = steps.map(function(s){ return $$('video.mgx-v', s); });
  /* las fotos del paso siguiente se descodifican antes de que entre (sin tirón al aparecer) */
  var imgs = steps.map(function(s){ return $$('img', s); }), dec = steps.map(function(){ return false; });
  var textures = steps.map(function(s){ return $$('[data-mgx-texture]', s); });
  function texture(i){ textures[i].forEach(function(el){ var url=el.getAttribute('data-mgx-texture'); if(url){el.style.setProperty('--m','url('+JSON.stringify(url)+')');el.removeAttribute('data-mgx-texture');} }); }
  function predecode(i){ if (dec[i]) return; dec[i] = true; texture(i); imgs[i].forEach(function(im){ try { im.loading = 'eager'; if (im.decode) im.decode().catch(function(){}); } catch(e){} }); }
  function media(i, on){ vids[i].forEach(function(v){ if (on) play(v); else pause(v); }); }

  /* ---------- precio 400 → 280: por tiempo, una sola vez, y se queda en el de miembro ---------- */
  var price = null, counted = false;
  function num(t){ var m = /\d[\d.,]*/.exec(t || ''); if (!m) return null; var s = m[0]; if (/[.,]\d{2}$/.test(s)) s = s.replace(/[.,](\d{2})$/, '#$1').replace(/[.,]/g, '').replace('#', '.'); else s = s.replace(/[.,]/g, ''); return parseFloat(s); }
  function fmt(v){ var s = price.dec ? v.toFixed(2) : String(Math.round(v)); if (price.comma) s = s.replace('.', ','); return price.pre + s + price.post; }
  function readPrice(){
    if (!pTo || !pFrom) return;
    var b = pTo.textContent, m = /\d[\d.,]*/.exec(b), a = num(pFrom.textContent), z = num(b);
    if (!m || a == null || z == null) return;
    price = { a: a, z: z, pre: b.slice(0, m.index), post: b.slice(m.index + m[0].length), dec: /[.,]\d{2}$/.test(m[0]), comma: /,\d{2}$/.test(m[0]), txt: b };
  }
  function armPrice(){ if (!price || counted || still) return; pTo.textContent = fmt(price.a); setv(pBox, '--sv', 0); }
  function countPrice(){
    if (!price || counted) return; counted = true;
    var t0 = 0, D = 1150;
    function step(ts){
      if (!t0) t0 = ts;
      var t = clamp((ts - t0) / D, 0, 1);
      pTo.textContent = t >= 1 ? price.txt : fmt(lerp(price.a, price.z, o3(t)));
      if (t < 1) requestAnimationFrame(step); else setv(pBox, '--sv', 1);
    }
    requestAnimationFrame(step);
  }
  function finishPrice(){ if (!price) return; counted = true; pTo.textContent = price.txt; setv(pBox, '--sv', 1); }

  /* ---------- medidas ---------- */
  var W = 0, H = 0, bx = null, mz = null, cam = null, cols = null;
  function measure(){
    vh = window.innerHeight;
    if (!pinned) return;
    S.style.setProperty('--mgx-len', ((END + 1) * 100) + 'vh');
    var sr = stage.getBoundingClientRect();
    W = sr.width; H = sr.height;
    irm.style.transform = 'none';
    var r = irs.getBoundingClientRect();
    setv(irm, '--ox', (r.left - sr.left + r.width * .5014) + 'px');
    setv(irm, '--oy', (r.top - sr.top + r.height * .5007) + 'px');
    if (irc) { setv(irc, '--ox', (r.left - sr.left + r.width * .5014) + 'px'); setv(irc, '--oy', (r.top - sr.top + r.height * .5007) + 'px'); irc.style.transform = 'none'; if (cache.get(irc)) delete cache.get(irc).transform; }
    if (cache.get(irm)) delete cache.get(irm).transform;
    /* cierre: el botón es la ventana inicial; el punto de «MIEMBRO.» es el centro del zoom */
    /* la franja del cierre mide lo que dejan libre avisos + pie: al llegar abajo, todo cabe en una pantalla */
    var aft = document.documentElement.scrollHeight - (S.getBoundingClientRect().bottom + window.scrollY);
    ctaIn.style.setProperty('--bh', Math.round(Math.min(H * .5, Math.max(H - aft, 300))) + 'px');
    ctaIn.style.clipPath = 'none'; mk.style.transform = 'none'; ol.style.transform = 'none';
    var cr = ctaIn.getBoundingClientRect(), b = btn.getBoundingClientRect(), d = dot.getBoundingClientRect(), mr = mk.getBoundingClientRect();
    bx = { t: b.top - cr.top, r: cr.right - b.right, b: cr.bottom - b.bottom, l: b.left - cr.left };
    var cx = d.left + d.width / 2 - mr.left, cy = d.top + d.height / 2 - mr.top;
    var far = Math.max(Math.hypot(cx, cy), Math.hypot(mr.width - cx, cy), Math.hypot(cx, mr.height - cy), Math.hypot(mr.width - cx, mr.height - cy));
    mz = { s0: Math.max(2, far / (d.width * .46)) };
    setv(mk, '--mox', cx + 'px'); setv(mk, '--moy', cy + 'px'); setv(ol, '--mox', cx + 'px'); setv(ol, '--moy', cy + 'px');
    if (cache.get(ctaIn)) delete cache.get(ctaIn).clipPath;
    if (cache.get(mk)) delete cache.get(mk).transform;
    if (cache.get(ol)) delete cache.get(ol).transform;
    /* 04: la cámara baja hasta la mano (punto 65,28 % · 73,08 % de la foto) */
    if (sc4.length) {
      /* medidas de maqueta (sin transformaciones): el punto de la mano en coordenadas del paso */
      var e0 = sc4[0];
      cam = { px: e0.offsetLeft + e0.offsetWidth * .6528, py: e0.offsetTop + e0.offsetHeight * .7308, tx: W * .6, ty: H * .52, s: 1.75 };
    }
    /* 04: columnas del borde en bloques (alturas pseudoaleatorias fijas) */
    var n = Math.max(12, Math.round(W / 64)); cols = [];
    for (var i = 0; i < n; i++) { var x = Math.sin(i * 12.9898 + 4.1) * 43758.5453; cols.push(x - Math.floor(x)); }
  }

  function blocks(p){
    if (p >= 1) return 'none';
    var n = cols.length, bw = W / n, spread = H * .55, pts = ['0px ' + H + 'px'];
    for (var i = 0; i < n; i++) {
      var h = clamp(p * (H + spread) - cols[i] * spread, 0, H + bw);
      h = Math.round(h / bw) * bw;
      var y = (H - h).toFixed(1);
      pts.push((i * bw).toFixed(1) + 'px ' + y + 'px', ((i + 1) * bw).toFixed(1) + 'px ' + y + 'px');
    }
    pts.push(W + 'px ' + H + 'px');
    return 'polygon(' + pts.join(',') + ')';
  }

  /* ---------- un fotograma (escenario fijo) ---------- */
  function frame(u){
    /* entrada: el «%» crece hasta llenar la pantalla con el humo del paso 01 */
    var z = seg(u, ZOOM[0], ZOOM[1]), pre = o3(seg(u, -.85, 0));
    sets(irm, 'transform', 'scale(' + (1 + Math.pow(z, 2.4) * 26).toFixed(4) + ')');
    sets(irs, 'transform', 'scale(' + (.82 + .18 * pre).toFixed(4) + ')');
    sets(irm, 'opacity', (1 - io(seg(z, .42, .92))).toFixed(4));
    sets(irm, 'visibility', z >= .99 ? 'hidden' : 'visible');
    if (irc) { sets(irc, 'transform', 'scale(' + (1 + Math.pow(z, 2.4) * 26).toFixed(4) + ')'); sets(irs2, 'transform', 'scale(' + (.82 + .18 * pre).toFixed(4) + ')'); sets(irc, 'opacity', (1 - o3(seg(z, 0, .22))).toFixed(4)); sets(irc, 'visibility', z >= .3 ? 'hidden' : 'visible'); }
    var hz = io(seg(z, 0, .34));
    sets(head, 'transform', 'translate3d(0,calc(' + (-50 - hz * 70).toFixed(3) + '% + ' + ((1 - pre) * 60).toFixed(1) + 'px),0)');
    sets(head, 'opacity', (1 - hz).toFixed(4));
    sets(cue, 'opacity', (1 - seg(z, 0, .2)).toFixed(4));

    for (var i = 0; i < steps.length; i++) {
      var el = steps[i], E = EN[i], X = EX[i], e = seg(u, E[0], E[1]);
      var on = (i === 0 ? u >= -1 : u >= E[0] - .02) && (i === LAST || u <= X[1] + .02);
      if (on) el.setAttribute('data-on', ''); else el.removeAttribute('data-on');
      var xo = seg(u, X[0], X[1]), o = i === LAST ? 0 : io(seg(xo, 0, .8));
      var k = seg(u, HO[i][0], HO[i][1]);
      var bg = 1, f, w, t;
      if (i === 0) { f = o3(seg(e, .2, .85)); w = o5(seg(e, .32, 1)); t = o3(seg(e, .58, 1)); }
      else if (i === 1) { bg = io(seg(e, 0, .62)); w = o5(seg(e, .4, 1)); f = o3(seg(e, .5, 1)); t = o3(seg(e, .62, 1)); }
      else if (i === 2) { w = 1; f = 1; t = o3(seg(e, .66, 1)); }
      else if (i === 4) { bg = io(seg(e, 0, .62)); w = o5(seg(e, .4, 1)); f = 1; t = o3(seg(e, .62, 1)); }
      else { w = o5(seg(e, .42, 1)); f = 1; t = o3(seg(e, .6, 1)); }
      setv(el, '--bg', bg); setv(el, '--f', f); setv(el, '--w', w); setv(el, '--t', t); setv(el, '--o', o); setv(el, '--k', k);
      setv(el, '--z', seg(u, i === 0 ? 0 : E[0], X[1]));
      setv(el, '--v', i === LAST ? 0 : .7 * o);
      setv(el, '--r', k - .5);
      if (bars[i]) setv(bars[i], '--s', seg(u, E[0] + .3, X[0]));
      if (i === 0) { if (t > .25) countPrice(); else if (u < E[0] - .3) armPrice(); }
      if (i === 1) setv(el, '--sp', Math.max(.12, k));
      if (i === 2 && s3bg) {
        /* tres bandas desde la izquierda, escalonadas; el filo arena va delante */
        var bw = W * .08;
        for (var j = 0; j < 3; j++) { var p = io(seg(e, j * .1, .52 + j * .1)) * (W + bw); setv(el, '--b' + (j + 1), p.toFixed(1) + 'px'); setv(el, '--b' + (j + 1) + 'px', p.toFixed(1) + 'px'); }
        setv(el, '--bw', bw.toFixed(1) + 'px');
      }
      if (i === 3) {
        setv(el, '--pxc', on ? blocks(seg(e, 0, .8)) : 'none');
        var cm = io(seg(k, .12, .6)), sg = io(seg(k, .5, .62));
        setv(el, '--cm', cm); setv(el, '--sg', sg);
        if (cam) {
          /* el fondo va dentro de .mgx-bgi, que escala (1,1 − 0,1·z) desde el centro: se corrige para que la mano acabe en (tx, ty) */
          var sb = 1.1 - .1 * seg(u, E[0], X[1]);
          var dx = (cam.tx - W / 2) / sb + W / 2 - cam.px, dy = (cam.ty - H / 2) / sb + H / 2 - cam.py;
          var tr = 'translate3d(' + (dx * cm).toFixed(1) + 'px,' + (dy * cm).toFixed(1) + 'px,0) scale(' + (1 + (cam.s - 1) * cm).toFixed(4) + ')';
          sc4.forEach(function(sc){ sets(sc, 'transform', tr); });
        }
      }
      var playing = near && on && o < .3 && (i === 0 ? true : i === 1 ? f > .5 : i === 2 ? t > .3 : false);
      media(i, playing);
    }
    /* que el siguiente paso ya esté cargado cuando llegue */
    for (var j2 = 0; j2 < steps.length; j2++) { if (near && u > EN[j2][0] - 1) vids[j2].forEach(load); if (near && u > EN[j2][0] - 1.6) predecode(j2); }
    /* cierre sobrio: el vídeo del público ya no se usa en ningún modo (no se carga) */

    /* indicador; el botón crece hasta ser la pantalla del cierre y la cámara sale del punto de «MIEMBRO.» */
    var ui = o3(seg(u, EN[0][0] + .35, EN[0][1]));
    setv(S, '--ui', ui);
    var c = io(seg(u, OUT[0], OUT[1]));
    sets(ui0, 'opacity', (ui * (1 - seg(c, 0, .3))).toFixed(4));
    if (bx) {
      var q2 = 1 - c;
      sets(ctaIn, 'clipPath', c >= 1 ? 'none' : 'inset(' + (bx.t * q2).toFixed(1) + 'px ' + (bx.r * q2).toFixed(1) + 'px ' + (bx.b * q2).toFixed(1) + 'px ' + (bx.l * q2).toFixed(1) + 'px)');
    }
    if (mz) {
      var m = io(seg(u, MASK[0], MASK[1])), ms = 'scale(' + Math.exp(Math.log(mz.s0) * (1 - m)).toFixed(4) + ')';
      sets(mk, 'transform', ms); sets(ol, 'transform', ms); sets(ol, 'opacity', Math.pow(m, 4).toFixed(4));
      sets(cv, 'transform', 'scale(' + (1 + .22 * m).toFixed(4) + ')');
    }
    setv(ctaIn, '--ci', o3(seg(u, ROW[0], ROW[1])));
    pause(cv);
    S.classList.toggle('is-cta', c > .9);
  }

  /* ---------- modo apilado (móvil / sin escenario): cada pantalla anima al entrar ---------- */
  function frameStacked(){
    for (var i = 0; i < steps.length; i++) {
      var el = steps[i], r = el.getBoundingClientRect();
      var vis = r.bottom > -vh * .2 && r.top < vh * 1.2;
      if (!vis) { media(i, false); continue; }
      predecode(i);
      var en = seg(vh - r.top, vh * .05, vh * .8);
      setv(el, '--w', o5(seg(en, .1, 1))); setv(el, '--f', o3(en)); setv(el, '--t', o3(seg(en, .35, 1))); setv(el, '--bg', 1); setv(el, '--o', 0);
      var k = seg(vh * .55 - r.top, 0, Math.max(r.height * .6, vh * .5));
      setv(el, '--k', k); setv(el, '--z', k);
      if (i === 1) setv(el, '--sp', Math.max(.12, k));
      if (i === 0) { if (r.top < vh * .45) countPrice(); else if (r.top > vh) armPrice(); }
      media(i, r.top < vh * .75 && r.bottom > vh * .25);
    }
    if (irv) { var ir = irv.getBoundingClientRect(); if (ir.bottom > 0 && ir.top < vh) play(irv); else pause(irv); }
  }

  function tick(ts){
    raf = 0;
    var r = S.getBoundingClientRect();
    near = r.top < vh * 1.6 && r.bottom > -vh * .6;
    if (!pinned) { if (!still) frameStacked(); return; }
    tgt = clamp(-r.top / vh, -1, END + .5);
    var dt = last ? Math.min(64, ts - last) : 16.7; last = ts;
    if (cur < -0.5 || !near || Math.abs(tgt - cur) > 2) cur = tgt;
    else cur += (tgt - cur) * (1 - Math.pow(1 - .16, dt / 16.7));
    if (Math.abs(tgt - cur) < .0004) cur = tgt;
    frame(cur);
    if (cur !== tgt) raf = requestAnimationFrame(tick); else last = 0;
  }
  function req(){ if (!raf) raf = requestAnimationFrame(tick); }

  function clearVars(){
    cache.forEach(function(m, el){ Object.keys(m).forEach(function(k){ if (k.charAt(0) === '-') el.style.removeProperty(k); else el.style[k] = ''; }); });
    cache = new Map();
    steps.forEach(function(s){ s.removeAttribute('data-on'); });
  }
  function mode(){
    var was = pinned;
    still = !!mqRM.matches;
    port = !mqLand.matches;
    pinned = !still; /* también en móvil: escena fija como «La marca» (12-10-2026) */
    if (was !== pinned) { clearVars(); cur = -1; last = 0; }
    S.classList.toggle('is-pin', pinned);
    if (!pinned) S.style.removeProperty('--mgx-len');
    if (still) { steps.forEach(function(s, i){ texture(i); media(i, false); }); pause(irv); pause(cv); finishPrice(); }
    if (pinned) pause(irv);
    measure();
    req();
  }

  /* con el teclado: si el foco entra en un paso, el scroll se coloca en ese paso */
  S.addEventListener('focusin', function(ev){
    if (!pinned) return;
    var li = ev.target.closest && ev.target.closest('.mgx-s'); var i = steps.indexOf(li);
    var top = S.getBoundingClientRect().top + window.pageYOffset;
    if (i > -1) window.scrollTo(0, top + (HO[i][0] + .05) * vh);
    else if (ev.target.closest && ev.target.closest('.mgx-cta')) window.scrollTo(0, top + END * vh);
  });

  function init(){
    readPrice();
    mode();
    armPrice();
    window.addEventListener('scroll', req, { passive: true });
    var rt = 0; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ mode(); }, 120); });
    [mqRM, mqLand].forEach(function(q){ if (q.addEventListener) q.addEventListener('change', mode); else if (q.addListener) q.addListener(mode); });
    document.addEventListener('visibilitychange', function(){ if (document.hidden) { steps.forEach(function(s, i){ media(i, false); }); pause(irv); pause(cv); } else req(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ measure(); req(); });
  }
  /* después de la demo (que pasa los precios a euros en DOMContentLoaded) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 0); });
  else init();
})();
